import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react';
import { Button, Col } from "reactstrap";
import { ModalContainer, ModalDialog } from 'react-modal-dialog';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FooterModal from '../../components/FooterModal';
import { IconeCarregar } from '../../components/Icones';
import { splitBR } from '../../../../utils/formatar';
import { toJS } from 'mobx';

@observer
export default class ConfigurableModal extends Component {

    constructor(props) {
        super(props)

        this.onKeyUpHandler = this.onKeyUpHandler.bind(this)
    }

    componentDidMount() { 
        const { onOpen } = this.props.modal.configuration;

        if (onOpen) onOpen();

        document.addEventListener('keyup', this.onKeyUpHandler);
    }

    componentWillUnmount() {
        document.removeEventListener('keyup', this.onKeyUpHandler);
    }

    onKeyUpHandler(e) {
        const { hideCancel, hideOk } = this.props.modal.configuration;

        switch (e.key) {
            case 'Enter':
                if (this.props.modal.isTopLevel && !hideOk) this.handleOkClick();
                break;
            case 'Escape':
                if (this.props.modal.isTopLevel && !hideCancel) this.handleCancelClick();
                break;
            default: break;
        }
    }

    handleOkClick = () => {
        const { disableOk, onClickOk, resetOnSave } = this.props.modal.configuration;
        if (disableOk) return;

        if (onClickOk) onClickOk();
        
        if(resetOnSave) this.props.modal.destroy();
    }
    
    handleCancelClick = () => {
        const { onClickCancel } = this.props.modal.configuration;
        
        if (onClickCancel) onClickCancel();

        this.props.modal.destroy();
    }

    handleButtonClick = index => event => {
        const { buttons } = this.props.modal.configuration;

        const { onClick, reset = true } = buttons.at(index);

        if (onClick) onClick();
        
        if(reset) this.props.modal.destroy();
    }

    render() {
        const { open, title, styles: { dialog: dialogStyles } = {}, className, classContainer, loading, saving, body, errorMessage, cancelLabel, okLabel, hideCancel, hideOk, disableOk, buttons } = this.props.modal.configuration;

        if (!open) return null;

        return (
            <ModalContainer zIndex={100} className={classContainer && classContainer}>
                <ModalDialog className={`nosso-modal modal-margin ${className && className}`} style={dialogStyles || {}}>
                    {loading ? (
                        <div className="text-center">
                            <h1>Aguarde por favor..</h1>
                            <FontAwesomeIcon icon="circle-notch" size={"2x"} className={"icone"} color={"#001C43"} spin />
                        </div>
                    ) : (
                        <Fragment>
                            {title && <h2>{title}</h2>}
                            {this.props.children}
                            {body && body}
                            {errorMessage && <Col className='mb-0 pr-0 text-right col label-danger'>{(typeof errorMessage == 'string') ? splitBR(errorMessage) : errorMessage}</Col>}
                            {((buttons && toJS(buttons).length > 0) || !hideCancel || !hideOk) && (
                                <FooterModal>
                                    <div className="justify-content-end">
                                        {this.props.salvando || saving ? (
                                            <IconeCarregar tamanho="2x"/>
                                        ) : (
                                            <Fragment>
                                                {buttons && buttons.map(({ label }, index) => (
                                                    <Button key={index} className="btn-primary" onClick={this.handleButtonClick(index)}> {label ? label : "CLIQUE AQUI"}</Button>
                                                ))}
                                                {!hideCancel && 
                                                    <Button className="btn-primary btn-modal-cancelar" onClick={this.handleCancelClick}> {cancelLabel ? cancelLabel : "FECHAR"}</Button>
                                                }
                                                {!hideOk &&
                                                    <Button 
                                                        className={`${disableOk ? "btn-disabled" : "btn-primary"} btn-modal-confirmar`} 
                                                        onClick={this.handleOkClick}
                                                    > 
                                                        {okLabel ? okLabel : "OK"}                      
                                                    </Button>
                                                }
                                            </Fragment>
                                        )}

                                    </div>
                                </FooterModal>
                            )}
                        </Fragment>
                    )}
                </ModalDialog>
            </ModalContainer>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/comum/modal/components/ConfigurableModal.js